export default "__VITE_PUBLIC_ASSET__335f2b9d__"